import React, { useEffect } from "react";

import ExternalLink from "../../components/ExternalLink";
import Heading from "../../components/Heading";
import { trackCustomEvent } from "../../utilities/analytics";

const embedIds = {
  "setimageracao.com.br/": {
    id: "d743d8a950c17f1209579d464a0cbee1c7611751",
    instaAccount: "setimageracaobr",
  },
  "omo.com/br": {
    id: "d9698f8c2e77e6c504ded3f8d326e5ee51d14e36",
    instaAccount: "omobrasil",
  },
};

interface EMBED_IDS {
  [key: string]: {
    id: string;
    instaAccount: string;
  };
}

type Props = {
  market: string;
};

const HomeInsta = ({ market }: Props) => {
  useEffect(() => {
    if (!Object.keys(embedIds).includes(market)) {
      return;
    }
    (function (d, s, id) {
      if (d.getElementById(id)) {
        return;
      }
      const js = d.createElement(s) as HTMLScriptElement;
      js.id = id;
      js.src = "https://embedsocial.com/cdn/ht.js";
      d.getElementsByTagName("head")[0].appendChild(js);
    })(document, "script", "EmbedSocialHashtagScript");

    const handleMessage = (event: MessageEvent) => {
      if (event.origin === "https://embedsocial.com" && event.data) {
        const MESSAGE = "message:";
        const messageIndex = event.data.indexOf(MESSAGE);

        if (messageIndex >= 0) {
          const messageString = event.data.substring(
            messageIndex + MESSAGE.length
          );
          const messageObj = JSON.parse(messageString);

          if (messageObj.action === "create") {
            trackCustomEvent({
              category: "Engagement",
              action: "click on instagram image",
              label: "embedded instagram",
            });
          }
          if (messageObj.action === "close") {
            trackCustomEvent({
              category: "Engagement",
              action: "close instagram image modal",
              label: "embedded instagram",
            });
          }
        }
      }
    };
    window.addEventListener("message", handleMessage, false);
    return function cleanupListener() {
      window.removeEventListener("message", handleMessage);
    };
  }, [market]);

  if (!Object.keys(embedIds).includes(market)) {
    return null;
  }

  const marketDetails = (embedIds as EMBED_IDS)[market];

  return (
    <section className="text-center">
      <Heading as="h2" className="p-10 text-2xl md:text-3xl md:p-14">
        INSTAGRAM
      </Heading>
      <div
        data-testid="embedsocial-hashtag"
        className="embedsocial-hashtag"
        data-ref={marketDetails.id as string}
      />
      <ExternalLink
        onClick={() => {
          trackCustomEvent({
            category: "Engagement",
            action: "click on link to instagram account",
            label: "embedded instagram",
          });
        }}
        href={`https://www.instagram.com/${marketDetails.instaAccount}/`}
        title={`@${marketDetails.instaAccount}`}
        showExternalIcon={false}
        className="inline-block px-10 py-3 my-10 text-white insta-link hover:text-white rounded-full font-bold text-base"
      >
        {`@${marketDetails.instaAccount}`}
      </ExternalLink>
    </section>
  );
};

export default HomeInsta;
